import React from 'react';

export default function SortableHeader({ label, column, sortBy, sortOrder, onSort }) {
  const isActive = sortBy === column;
  const arrow = isActive ? (sortOrder === 'asc' ? ' ▲' : ' ▼') : '';

  return (
    <th
      className={`sortable-header ${isActive ? 'active' : ''}`}
      onClick={() => onSort(column)}
      style={{ cursor: 'pointer', userSelect: 'none' }}
    >
      {label}{arrow}
    </th>
  );
}
